var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Nav__Container"},[(_vm.step === 0)?_c('Home'):_vm._e(),(_vm.step === 1)?_c('Shape'):_vm._e(),(_vm.step === 2)?_c('Texture'):_vm._e(),(_vm.step === 3)?_c('Save'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }